import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * App Bridge NavMenu — renders navigation links in the Shopify Admin sidebar.
 * Uses the <ui-nav-menu> custom element from App Bridge CDN.
 * These appear under the app name in the left admin panel.
 */
export default function AppNav() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // App Bridge handles click events on nav-menu links automatically
    // and navigates the iframe. We just need to render the element.
  }, []);

  return (
    <ui-nav-menu>
      <a href="/" rel="home">Vendors</a>
      <a href="/purchase-orders">All Purchase Orders</a>
      <a href="/receiving">Receiving</a>
      <a href="/price-labels">Price Labels</a>
      <a href="/purchase-orders?status=draft">Draft POs</a>
      <a href="/settings">Settings</a>
    </ui-nav-menu>
  );
}
